import { render } from "./AltriPagamentiDataTable.vue?vue&type=template&id=2a8219c9"
import script from "./AltriPagamentiDataTable.vue?vue&type=script&lang=js"
export * from "./AltriPagamentiDataTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__